import { ESmartNowActions, SmartNowActions } from "@edp-store/actions/smart-now.actions";
import { initialSmartNowState, ISmartNowState } from "@edp-store/state/smart-now.state";

export function smartNowReducers(state = initialSmartNowState, action: SmartNowActions): ISmartNowState {
    switch (action.type) {
        case ESmartNowActions.SetSmartNowStatus: {
            return {
                ...state,
                status: action.payload,
            };
        }
        case ESmartNowActions.SmartNowAPIError: {
            return {
                ...state,
                lastAPIError: action.error,
            };
        }
        case ESmartNowActions.SetHouseCharacterization: {
            return {
                ...state,
                houseCharacterization: action.payload,
            };
        }
        case ESmartNowActions.SetConsumptionWithDisaggregation: {
            return {
                ...state,
                consumptionWithDesaggregation: action.payload,
            };
        }
        case ESmartNowActions.SetStep: {
            return {
                ...state,
                step: action.payload,
            };
        }
        case ESmartNowActions.SetPreviousStepUrl: {
            return {
                ...state,
                previousStepUrl: action.payload,
            };
        }
        case ESmartNowActions.SetFlowOrigin: {
            return {
                ...state,
                flowOrigin: action.payload,
            };
        }
        case ESmartNowActions.SetConsumptionPrediction: {
            return {
                ...state,
                prediction: action.payload,
            };
        }
        case ESmartNowActions.SetContractOptimization: {
            return {
                ...state,
                contractOptimization: action.payload,
            };
        }
        case ESmartNowActions.SetConsumptionPower: {
            return {
                ...state,
                consumptionPower: action.payload,
            };
        }
        case ESmartNowActions.SetConsumptionHistory: {
            return {
                ...state,
                consumptionHistory: action.payload,
            };
        }
        case ESmartNowActions.SetCurrentPeriodConsumption: {
            return {
                ...state,
                currentPeriodConsumption: action.payload,
            };
        }
        case ESmartNowActions.SetConsumptionEvolution: {
            return {
                ...state,
                consumptionEvolution: action.payload,
            };
        }
        case ESmartNowActions.SetEfficiencyEnergetic: {
            return {
                ...state,
                efficiencyEnergetic: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
